/* chats feature – reducer */
import {
  ChatViewModel,
  ChatDetailsViewModel,
  ChatMessageViewModel,
} from "../../configuration/api/apiSchema";

export interface ChatState {
  chats: ChatViewModel[];             // full list (initial load)
  searchResults: ChatViewModel[];     // last search payload
  chatDetails: ChatDetailsViewModel | null;
  loading: boolean;                   // generic spinner (list, details, create, send)
  searchLoading: boolean;             // spinner just for search box
  error: any;
}

const initialState: ChatState = {
  chats: [],
  searchResults: [],
  chatDetails: null,
  loading: false,
  searchLoading: false,
  error: null,
};

export const reducer = (state = initialState, action: any): ChatState => {
  switch (action.type) {
    /* ─────────────────────────────────── */
    /*  GET ALL CHATS                      */
    /* ─────────────────────────────────── */
    case "GET_CHATS_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_CHATS_SUCCESS":
      return { ...state, loading: false, chats: action.payload };
    case "GET_CHATS_FAILURE":
      return { ...state, loading: false, error: action.payload };

    /* ─────────────────────────────────── */
    /*  GET CHAT DETAILS                   */
    /* ─────────────────────────────────── */
    case "GET_CHAT_DETAILS_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_CHAT_DETAILS_SUCCESS":
      return { ...state, loading: false, chatDetails: action.payload };
    case "GET_CHAT_DETAILS_FAILURE":
      return { ...state, loading: false, error: action.payload };

    /* ─────────────────────────────────── */
    /*  CREATE CHAT                        */
    /* ─────────────────────────────────── */
    case "CREATE_CHAT_REQUEST":
      return { ...state, loading: true, error: null };
    case "CREATE_CHAT_SUCCESS":
      return {
        ...state,
        loading: false,
        chats: [...state.chats, { id: action.payload } as ChatViewModel],
      };
    case "CREATE_CHAT_FAILURE":
      return { ...state, loading: false, error: action.payload };

    /* ─────────────────────────────────── */
    /*  SEND MESSAGE                       */
    /* ─────────────────────────────────── */
    case "SEND_MESSAGE_REQUEST":
      return { ...state, loading: true, error: null };
    case "SEND_MESSAGE_SUCCESS":
      return {
        ...state,
        loading: false,
        chatDetails: state.chatDetails
          ? {
              ...state.chatDetails,
              messages: [
                ...(state.chatDetails.messages || []),
                action.payload as ChatMessageViewModel,
              ],
            }
          : state.chatDetails,
      };
    case "SEND_MESSAGE_FAILURE":
      return { ...state, loading: false, error: action.payload };

    /* ─────────────────────────────────── */
    /*  SEARCH CHATS                       */
    /* ─────────────────────────────────── */
    case "chats/SEARCH_REQUEST":
      return { ...state, searchLoading: true, error: null };
    case "chats/SEARCH_SUCCESS":
      return { ...state, searchLoading: false, searchResults: action.payload };
    case "chats/SEARCH_FAILURE":
      return { ...state, searchLoading: false, error: action.payload };

    /* ─────────────────────────────────── */
    default:
      return state;
  }
};
